import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider } from './components/AppContext';
import App from "./components/App";

// Import axios interceptor to handle subscription errors
import './utils/axiosInterceptor';

// Import styles
import './locales/i18n';
// import './styles/app.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/icomoon/style.css';
import './styles/magicwand.css';
import "./index.css";
import "./styles/shell.css";
import "./styles/onboarding.css";
import "./styles/fa/css/all.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import 'react-toastify/dist/ReactToastify.css';
import "./styles/theme.css";
import "./styles/mailing.css";

const root = ReactDOM.createRoot(document.getElementById("app"));

root.render(
  <React.StrictMode>
    <AppProvider>
      <Router>
        <App />
      </Router>
    </AppProvider>
  </React.StrictMode>
);
